import { useNavigate } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import { Button } from "@mui/material";
import {
  ResponsiveContainer,
  Tooltip,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
  Cell,
} from "recharts";

const COLORS = ["#0088FE", "#FF8042", "#FF6384", "#4BC0C0", "#00C49F"];

// Chart Data
const totalCustomers = [
  { name: "Mon", count: 50 },
  { name: "Tue", count: 65 },
  { name: "Wed", count: 80 },
  { name: "Thu", count: 70 },
  { name: "Fri", count: 90 },
  { name: "Sat", count: 120 },
  { name: "Sun", count: 110 },
];

const totalProviders = [
  { name: "Mon", count: 10 },
  { name: "Tue", count: 12 },
  { name: "Wed", count: 15 },
  { name: "Thu", count: 14 },
  { name: "Fri", count: 18 },
  { name: "Sat", count: 20 },
  { name: "Sun", count: 22 },
];

const totalBookings = [
  { name: "Mon", count: 25 },
  { name: "Tue", count: 30 },
  { name: "Wed", count: 28 },
  { name: "Thu", count: 35 },
  { name: "Fri", count: 40 },
  { name: "Sat", count: 50 },
  { name: "Sun", count: 45 },
];

const ManageReports = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="main_title d_flex">
        <div className="left_s">
          <h1>Reports Management</h1>
          <p>
            <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Reports Management
          </p>
        </div>
        <div className="right_s">
          <Button className="btn btn_primary"><DownloadIcon /> Export</Button>
        </div>
      </div>

      <div className="grid_sc pt_0 gap_m">
        {/* 1. Total Customers */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Total Customers</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={totalCustomers}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#0088FE" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* 2. Total Service Providers */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Total Service Providers</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={totalProviders}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#4BC0C0" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* 3. Total Bookings */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Total Bookings</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={totalBookings}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count">
                {totalBookings.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
};

export default ManageReports;
